import React, { useState, useEffect, useRef } from 'react';
import logo from '../../assets/logo.jpeg';
import {
  ChevronDown,
  ChevronUp,
  Home,
  User,
  Users,
  DollarSign,
  Download,
  Briefcase,
  BarChart2,
  MessageSquare,
  CreditCard,
  Globe,
  Mail,
  Settings,
  LogOut,
  Menu,
  X,
  ChevronLeft,
  ChevronRight,
  Wallet
} from 'lucide-react';

// Import all components
import DashboardOverview from './DashboardOverview';
import AccountDetails from './AccountDetails';
import ChangePassword from './ChangePassword';
import Rewardsettings from './Rewardsettings';
import CompanyCryptoDetails from './CompanyCryptoDetails';
import MasterProduct from './MasterProduct';
import AddPackage from './AddPackage';
import MemberList from './MemberList';
import ActivateMember from './ActivateMember';
import InactiveMember from './InactiveMember';
import SponsorWiseList from './SponsorWiseList';
import LevelWiseList from './LevelWiseList';
import TeamWithdrawalReport from './TeamWithdrawalReport';
import EditedWithdrawal from './EditedWithdrawal';
import TeamEWalletReport from './TeamEWalletReport';
import MemberAddress from './MemberAddress';
import FundAddByAdmin from './FundAddByAdmin';
import LatestRegistrations from './LatestRegistrations';
import ActivationReport from './ActivationReport';
import RejectFund from './RejectFund';
import FundHistory from './FundHistory';
import FundByAdminHistory from './FundByAdminHistory';
import FundTransferHistory from './FundTransferHistory';
import Deposit from './Deposit';
import ROILevelReport from './ROILevelReport';
import DepositHistory from './DepositHistory';
import WalletReport from './WalletReport';
import IncomeReportPage from './IncomeReportPage';
import ROIReport from './ROIReport';
import LevelReport from './LevelReport';
import EnergyReport from './EnergyReport';
import WithdrawalRequest from './WithdrawalRequest';
import WithdrawalHistory from './WithdrawalHistory';
import WithdrawalSetting from './WithdrawalSetting';
import News from './News';
import TicketReport from './TicketReport';
import TicketCompleted from './TicketCompleted';
import ProcessROI from './ProcessROI';
import CryptoPaymentReport from './CryptoPaymentReport';
import LeaderRewards from './LeaderRewards';
import Adminloginreports from './Adminloginreports';
import Scratch from './Scratch';

const AdminDashboard = () => {
  const [openDropdown, setOpenDropdown] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
  const [selectedComponent, setSelectedComponent] = useState('DashboardOverview');
  const [isMobile, setIsMobile] = useState(false);
  const sidebarRef = useRef(null);

  // Check if mobile on mount and resize
  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < 1024);
    };
    
    checkIfMobile();
    window.addEventListener('resize', checkIfMobile);
    
    return () => {
      window.removeEventListener('resize', checkIfMobile);
    };
  }, []);

  // Auto-close mobile sidebar when switching to desktop
  useEffect(() => {
    if (!isMobile && isMobileSidebarOpen) {
      setIsMobileSidebarOpen(false);
    }
  }, [isMobile, isMobileSidebarOpen]);

  const toggleDropdown = (label) => {
    setOpenDropdown(openDropdown === label ? null : label);
  };

  const toggleDesktopSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const toggleMobileSidebar = () => {
    setIsMobileSidebarOpen(!isMobileSidebarOpen);
  };

  const handleLogout = () => {
    localStorage.clear();
    window.location.href = '/login';
  };

  // auto logout after 15 minutes of inactivity
  useEffect(() => {
    let timeoutId;
    const resetTimer = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(handleLogout, 15 * 60 * 1000);
    };
    const events = ['mousemove', 'keydown', 'click', 'scroll'];
    events.forEach((e) => document.addEventListener(e, resetTimer));
    resetTimer();
    return () => {
      clearTimeout(timeoutId);
      events.forEach((e) => document.removeEventListener(e, resetTimer));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleMenuClick = (componentName) => {
    setSelectedComponent(componentName);
    if (isMobileSidebarOpen) setIsMobileSidebarOpen(false);
  };

  const menuItems = [
    { 
      label: 'Dashboard', 
      icon: Home,
      component: 'DashboardOverview'
    },
    {
      label: 'Admin Zone',
      icon: User,
      dropdown: [
        // { label: 'Account Details', component: 'AccountDetails' },
        // { label: 'Change Password', component: 'ChangePassword' },
        { label: 'Admin login Reports', component: 'adminloginreports' },
         { label: 'Latest Registrations', component: 'LatestRegistrations' },
        { label: 'Member Report', component: 'CryptoPaymentReport' },
        { label: 'Member Address', component: 'MemberAddress' },
        { label: 'ROI Product', component: 'MasterProduct' },
        { label: 'Add Package', component: 'AddPackage' },
      ],
    },
    {
      label: 'Member Zone',
      icon: Users,
      dropdown: [
        { label: 'Member List', component: 'MemberList' },
        { label: 'Activate Member', component: 'ActivateMember' },
        { label: 'Inactive Member', component: 'InactiveMember' },
        { label: 'Activation Report', component: 'ActivationReport' },
        { label: 'Sponsor Wise List', component: 'SponsorWiseList' },
        { label: 'Level Wise List', component: 'LevelWiseList' },
        // { label: 'Team Withdrawal Report', component: 'TeamWithdrawalReport' },
       
      ],
    },
    {
      label: 'Fund Management',
      icon: Wallet,
      dropdown: [
        { label: 'Add Fund', component: 'FundAddByAdmin' },
        { label: 'User Fund History', component: 'FundHistory' },
        { label: 'Admin Fund History', component: 'FundByAdminHistory' },
        { label: 'Fund Transfer History', component: 'FundTransferHistory' },
        { label: 'Scratch Report', component: 'Scratch' },
      ],
    },
    {
      label: 'Wallet Management',
      icon: Briefcase,
      dropdown: [
        { label: 'Wallet Report', component: 'WalletReport' },
      ],
    },
    {
      label: 'Income Report',
      icon: BarChart2,
      dropdown: [
        { label: 'Income Report', component: 'IncomeReportPage' },
        { label: 'Level Report', component: 'LevelReport' },
        { label: 'ROI Daily Report', component: 'ROIReport' },
        { label: 'ROI Income Report', component: 'ROILevelReport' },
        { label: 'Energy Report', component: 'EnergyReport' },
      ],
    },
    {
      label: 'Withdrawal',
      icon: CreditCard,
      dropdown: [
        { label: 'Withdrawal Request', component: 'WithdrawalRequest' },
        // { label: 'Edited Withdrawal', component: 'EditedWithdrawal' },
        { label: 'Withdrawal History', component: 'WithdrawalHistory' },
        { label: 'Withdrawal Setting', component: 'WithdrawalSetting' },

      ],
    },
    {
      label: 'Rewards setting',
      icon: Briefcase,
      dropdown: [
        { label: 'Reward settings', component: 'Rewardsettings' },
         { label: 'Reward Report', component: 'Leaderrewardreport' },
      ],
    },
    {
      label: 'Website Management',
      icon: Globe,
      dropdown: [
        { label: 'News', component: 'News' },
      ],
    },
    {
      label: 'Support',
      icon: Mail,
      dropdown: [
        { label: 'Ticket Report', component: 'TicketReport' },
      ],
    },
  ];

  // Render the current component
  const renderComponent = () => {
    switch(selectedComponent) {
      case 'DashboardOverview':
        return <DashboardOverview onNavigate={handleMenuClick} />;
      case 'AccountDetails':
        return <AccountDetails />;
      case 'ChangePassword':
        return <ChangePassword />;
      case 'Rewardsettings':
        return <Rewardsettings />;
      case 'CompanyCryptoDetails':
        return <CompanyCryptoDetails />;
      case 'MasterProduct':
        return <MasterProduct />;
      case 'AddPackage':
        return <AddPackage />;
      case 'MemberList':
        return <MemberList />;
      case 'ActivateMember':
        return <ActivateMember />;
      case 'InactiveMember':
        return <InactiveMember />;
      case 'SponsorWiseList':
        return <SponsorWiseList />;
      case 'LevelWiseList':
        return <LevelWiseList />;
      case 'TeamWithdrawalReport':
        return <TeamWithdrawalReport />;
      case 'EditedWithdrawal':
        return <EditedWithdrawal />;
      case 'TeamEWalletReport':
        return <TeamEWalletReport />;
      case 'MemberAddress':
        return <MemberAddress />;
      case 'FundAddByAdmin':
        return <FundAddByAdmin />;
      case 'FundByAdminHistory':
        return <FundByAdminHistory />;
      case 'LatestRegistrations':
  return <LatestRegistrations />;
      case 'ActivationReport':
        return <ActivationReport />;
      case 'RejectFund':
        return <RejectFund />;
      case 'FundHistory':
        return <FundHistory />;
      case 'FundTransferHistory':
        return <FundTransferHistory />;
      case 'Deposit':
        return <Deposit />;
      case 'DepositHistory':
        return <DepositHistory />;
      case 'WalletReport':
        return <WalletReport />;
      case 'IncomeReportPage':
        return <IncomeReportPage />;
      case 'ROILevelReport':
        return <ROILevelReport />;
      case 'ROIReport':
        return <ROIReport />;
      case 'LevelReport':
        return <LevelReport />;
      case 'EnergyReport':
        return <EnergyReport />;
      case 'WithdrawalRequest':
        return <WithdrawalRequest />;
      case 'WithdrawalHistory':
        return <WithdrawalHistory />;
      case 'WithdrawalSetting':
        return <WithdrawalSetting />;
      case 'News':
        return <News />;
      case 'TicketReport':
        return <TicketReport />;
      case 'TicketCompleted':
        return <TicketCompleted />;
      case 'ProcessROI':
        return <ProcessROI />;
      case 'CryptoPaymentReport':
        return <CryptoPaymentReport />;
      case 'Leaderrewardreport':
        return <LeaderRewards />;
      case 'adminloginreports':
        return <Adminloginreports />;
      case 'Scratch':
        return <Scratch />;
      default:
        return <DashboardOverview onNavigate={handleMenuClick} />;
    }
  };

  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col">
      {/* Fixed Top Header - Mobile Optimized */}
      <header className="fixed top-0 left-0 right-0 bg-gradient-to-r from-navy-dark to-navy-deep py-3 px-4 flex items-center justify-between shadow-lg z-50 border-b border-primary/30 backdrop-blur-lg">
        <div className="flex items-center gap-3">
          <button
            onClick={toggleMobileSidebar}
            className="text-primary hover:text-accent transition lg:hidden"
            aria-label="Toggle menu"
          >
            {isMobileSidebarOpen ? <X size={20} /> : <Menu size={20} />}
          </button>
          <div 
            className="flex items-center cursor-pointer" 
            onClick={() => handleMenuClick('DashboardOverview')}
          >
            <div className="relative w-10 h-10 sm:w-12 sm:h-12 rounded-full overflow-hidden border border-primary/30 hover:border-primary transition-colors pulse-glow group flex items-center justify-center bg-background">
              <img src={logo} alt="logo" className="w-full h-full object-cover" />
            </div>
          </div>
        </div>

        <div className="flex items-center gap-2">
          <div className="hidden xs:block text-xs sm:text-sm text-silver font-medium font-heading">
            Welcome, <span className="text-primary font-bold">Admin</span>
          </div>

          <button
            onClick={handleLogout}
            className="flex items-center gap-1 text-red-400 hover:text-red-300 transition-colors font-medium px-3 py-1.5 sm:px-4 sm:py-2 rounded-lg hover:bg-red-900/20 border border-red-500/30 hover:border-red-500/50 text-xs sm:text-sm"
          >
            <LogOut size={14} className="sm:size-4" />
            <span className="hidden xs:inline">Logout</span>
          </button>
        </div>
      </header>

      {/* Main Layout */}
      <div className="flex flex-1 pt-14">
        {/* Desktop Sidebar - Unchanged */}
        <aside
          ref={sidebarRef}
          className={`
            hidden lg:flex
            fixed top-14 left-0 h-[calc(100vh-3.5rem)]
            bg-gradient-to-b from-navy-dark/90 to-navy-deep/90
            border-r border-primary/20
            flex flex-col
            z-40
            transition-all duration-300 ease-in-out
            backdrop-blur-lg
            ${isSidebarOpen ? 'w-[280px]' : 'w-[80px]'}
          `}
          style={{ minWidth: isSidebarOpen ? '280px' : '80px' }}
        >
          {/* Collapse Button */}
          <div className="flex items-center justify-end p-4">
            <button
              onClick={toggleDesktopSidebar}
              className="text-primary hover:text-accent transition p-2 rounded-lg hover:bg-primary/10 border border-primary/20"
              aria-label={isSidebarOpen ? "Collapse sidebar" : "Expand sidebar"}
            >
              {isSidebarOpen ? <ChevronLeft size={20} /> : <ChevronRight size={20} />}
            </button>
          </div>

          {/* Scrollable Menu */}
          <nav className="flex-1 overflow-y-auto px-4 pb-4">
            <div className="space-y-2">
              {menuItems.map((item) => (
                <div key={item.label} className="mb-2">
                  {item.dropdown ? (
                    <button
                      onClick={() => toggleDropdown(item.label)}
                      className={`
                        w-full flex items-center justify-between
                        px-4 py-3 rounded-xl transition-all
                        ${openDropdown === item.label
                          ? 'bg-primary/20 text-primary border border-primary/30 shadow-electric'
                          : 'hover:bg-primary/10 text-silver hover:text-silver-light border border-transparent hover:border-primary/20'}
                      `}
                    >
                      <div className="flex items-center gap-4 min-w-0">
                        <item.icon size={24} className="flex-shrink-0" />
                        {isSidebarOpen && (
                          <span className="font-medium text-base whitespace-nowrap font-heading">
                            {item.label}
                          </span>
                        )}
                      </div>
                      {isSidebarOpen && (
                        openDropdown === item.label ? 
                        <ChevronUp size={20} className="flex-shrink-0 ml-2 text-primary" /> : 
                        <ChevronDown size={20} className="flex-shrink-0 ml-2 text-silver" />
                      )}
                    </button>
                  ) : (
                    <button
                      onClick={() => handleMenuClick(item.component)}
                      className={`
                        w-full flex items-center gap-4 px-4 py-3 rounded-xl transition-all
                        ${selectedComponent === item.component
                          ? 'bg-primary/20 text-primary border border-primary/30 shadow-electric'
                          : 'hover:bg-primary/10 text-silver hover:text-silver-light border border-transparent hover:border-primary/20'}
                      `}
                    >
                      <item.icon size={24} className="flex-shrink-0" />
                      {isSidebarOpen && (
                        <span className="font-medium text-base whitespace-nowrap font-heading">
                          {item.label}
                        </span>
                      )}
                    </button>
                  )}

                  {/* Dropdown Items */}
                  {item.dropdown && openDropdown === item.label && isSidebarOpen && (
                    <div className="mt-2 ml-3 space-y-1">
                      {item.dropdown.map((sub) => (
                        <button
                          key={sub.component}
                          onClick={() => handleMenuClick(sub.component)}
                          className={`
                            w-full text-left block px-4 py-2 rounded-lg text-sm transition-all font-body
                            ${selectedComponent === sub.component
                              ? 'bg-primary/30 text-primary border-l-4 border-primary'
                              : 'hover:bg-primary/15 text-silver hover:text-silver-light'}
                            whitespace-normal text-left break-words border-l border-primary/10
                          `}
                        >
                          <span className="block w-full text-left">{sub.label}</span>
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
            
            <div className="h-20" />
          </nav>
        </aside>

        {/* Mobile Sidebar Overlay */}
        {isMobileSidebarOpen && (
          <div
            className="fixed inset-0 bg-black/70 z-30 lg:hidden backdrop-blur-sm"
            onClick={toggleMobileSidebar}
          />
        )}

        {/* Mobile Sidebar Drawer */}
        <aside
          className={`
            fixed top-14 left-0 h-[calc(100vh-3.5rem)]
            bg-gradient-to-b from-navy-dark to-navy-deep
            border-r border-primary/30
            flex flex-col
            z-40
            transition-all duration-300 ease-in-out
            w-72
            backdrop-blur-lg
            ${isMobileSidebarOpen ? 'translate-x-0' : '-translate-x-full'}
            lg:hidden
          `}
        >
          {/* Mobile Sidebar Header */}
          <div className="p-4 border-b border-primary/30">
            <div className="flex items-center justify-between">
              <span className="text-primary font-semibold font-heading">Admin Menu</span>
              <button
                onClick={toggleMobileSidebar}
                className="text-primary hover:text-accent transition"
                aria-label="Close menu"
              >
                <X size={20} />
              </button>
            </div>
          </div>

          {/* Mobile Menu Items */}
          <nav className="flex-1 overflow-y-auto px-4 py-4">
            <div className="space-y-1">
              {menuItems.map((item) => (
                <div key={item.label} className="mb-1">
                  {item.dropdown ? (
                    <div>
                      <button
                        onClick={() => toggleDropdown(item.label)}
                        className={`
                          w-full flex items-center justify-between
                          px-3 py-2.5 rounded-lg transition-all
                          ${openDropdown === item.label
                            ? 'bg-primary/20 text-primary border border-primary/30'
                            : 'hover:bg-primary/10 text-silver hover:text-silver-light'}
                        `}
                      >
                        <div className="flex items-center gap-3 min-w-0">
                          <item.icon size={18} className="flex-shrink-0" />
                          <span className="font-medium text-sm truncate font-heading">{item.label}</span>
                        </div>
                        {openDropdown === item.label ? 
                          <ChevronUp size={16} className="flex-shrink-0 ml-2 text-primary" /> : 
                          <ChevronDown size={16} className="flex-shrink-0 ml-2 text-silver" />
                        }
                      </button>
                      
                      {/* Mobile Dropdown Items */}
                      {openDropdown === item.label && (
                        <div className="mt-1 ml-6 space-y-0.5">
                          {item.dropdown.map((sub) => (
                            <button
                              key={sub.component}
                              onClick={() => handleMenuClick(sub.component)}
                              className={`
                                w-full text-left block px-3 py-1.5 rounded text-xs transition-all truncate font-body
                                ${selectedComponent === sub.component
                                  ? 'bg-primary/30 text-primary border-l-2 border-primary'
                                  : 'hover:bg-primary/15 text-silver hover:text-silver-light'}
                              `}
                            >
                              {sub.label}
                            </button>
                          ))}
                        </div>
                      )}
                    </div>
                  ) : (
                    <button
                      onClick={() => handleMenuClick(item.component)}
                      className={`
                        w-full flex items-center gap-3 px-3 py-2.5 rounded-lg transition-all
                        ${selectedComponent === item.component
                          ? 'bg-primary/20 text-primary border border-primary/30'
                          : 'hover:bg-primary/10 text-silver hover:text-silver-light'}
                      `}
                    >
                      <item.icon size={18} />
                      <span className="font-medium text-sm truncate font-heading">{item.label}</span>
                    </button>
                  )}
                </div>
              ))}
            </div>
            
            <div className="h-8" />
          </nav>
        </aside>

        {/* Main Content Area */}
        <main
          className={`
            flex-1
            bg-gradient-to-b from-navy-dark/50 to-background
            overflow-y-auto
            transition-all duration-300
            w-full
            ${!isMobile && isSidebarOpen ? 'lg:ml-[280px]' : 'lg:ml-[80px]'}
          `}
        >
          <div className="p-3 sm:p-4 md:p-6 min-h-[calc(100vh-3.5rem)]">
            <div className="max-w-full mx-auto">
              {/* Page Title - Mobile Only */}
              <div className="lg:hidden mb-4">
                <h1 className="text-lg font-bold text-primary mb-1 font-heading">
                  {menuItems.find(item => 
                    item.component === selectedComponent || 
                    (item.dropdown && item.dropdown.some(sub => sub.component === selectedComponent))
                  )?.label || 'Dashboard'}
                </h1>
                <div className="h-px bg-gradient-to-r from-primary/30 to-transparent"></div>
              </div>
              
              {/* Render Component */}
              <div className="glass p-3 sm:p-4 rounded-lg border border-primary/10 card-glow">
                {renderComponent()}
              </div>
            </div>
          </div>
        </main>
      </div>

 

      {/* Custom Scrollbar Styles */}
      <style jsx>{`
        /* Custom scrollbar for mobile */
        .overflow-y-auto {
          scrollbar-width: thin;
          scrollbar-color: hsl(var(--primary) / 0.3) transparent;
        }
        
        .overflow-y-auto::-webkit-scrollbar {
          width: 3px;
        }
        
        .overflow-y-auto::-webkit-scrollbar-track {
          background: transparent;
        }
        
        .overflow-y-auto::-webkit-scrollbar-thumb {
          background-color: hsl(var(--primary) / 0.3);
          border-radius: 4px;
        }
        
        .overflow-y-auto::-webkit-scrollbar-thumb:hover {
          background-color: hsl(var(--primary) / 0.5);
        }
      `}</style>
    </div>
  );
};

export default AdminDashboard;
